document.addEventListener("turbolinks:load", () => {

  // adds js to dinamically created nested fields for inverter usage
  $('#roof_images, #input_pattern_images, #switchboard_images').on('cocoon:after-insert', function(e, insertedItem) {
    add_file_input();
  });


});
